<template>
  <div class="chat-container w-100 position-relative bg-white">
    <div id="Reward"></div>
    <div class="position-relative z-index-1028">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-top d-block nav-bottom">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div class="bg-white">
                  <div class="container px-4 w-100 py-1">
                    <div class="row no-gutters py-2 m-0 w-100">
                      <!-- <div class="col-1">
                        <div class="">
                          <router-link :to="'/'+getMerchant().code+'/concierge/reward'">
                            <img src="../../../../assets/img/icon/back-arrow.png" class="mt-1" width="15">
                          </router-link>
                        </div>
                      </div> -->
                      <div class="col-9">
                        <div class="">
                          <transition name="fade">
                            <p class="mb-0 body-1-2 nav-hotel ml-3 mt-1">{{$t('hotel.concierge.membership')}}</p>
                          </transition>
                        </div>
                      </div>
                      <!-- <div class="col-2 text-right">
                        <router-link :to="'/'+getMerchant().code+'/concierge/reward/my-reward'">
                          <div class="notif" style="left: auto;right: -4px;top: 3px;" v-if="reward_selected"></div>
                          <img src="../../../../assets/img/icon/concierge/coupon.png" class="mt-1" width="24">
                        </router-link>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 65px"></div>
    <!-- Saat Menjadi Member -->
    <template>
      <!-- Profile & Card -->
      <div class="container px-4 mb-4 pt-3">
        <div class="row slim-grid-row">
          <div class="col-12 align-self-center">
            <div class="d-inline-block align-middle mr-3">
              <img :src="getCurrentUser().avatar" class="rounded-50 img-profil">
            </div>
            <div class="d-inline-block align-middle" style="width: 60%;">
              <p class="mb-0 body-2-2 text-18 font-extrabold text-truncate">{{guest_name}}</p>
              <div class="">
                <template v-if="code == 'MEMBER'">
                  <i :style="{color:data.card_color_accent}" style="font-size:18px;" class="d-inline-block align-middle simple-icon-credit-card"></i>
                  <p class="mb-0 body-2-2 d-inline-block align-middle ml-1">{{data.card_name}} Member</p>
                </template>
                <p v-if="code == 'MEMBER_ON_REQUEST'" class="mb-0 body-3-3-1">{{$t('general.membership-being-processed')}}</p>
              </div>
            </div>
          </div>
          <!-- <div class="col-2 align-self-center text-right">
            <router-link :to="'/'+getMerchant().code+'/concierge/member/my-member'">
              <p class="mb-0 body-2-2 text-12 text-green underline cursor-pointer">Detail</p>
            </router-link>
          </div> -->
        </div>
        <div class="py-3 mt-2">
          <MemberCard :data="parsingDataCard(data)" :guest_name="guest_name" :disabled="code == 'MEMBER_ON_REQUEST'" @detail="cardClicked"></MemberCard>
        </div>
        <p v-if="code == 'MEMBER_ON_REQUEST'" class="mb-4 body-2-2 text-12 text-green underline cursor-pointer" @click="goToCardList()">{{$t('general.see-more-membership-offers')}}</p>
        <div id="reward_list"></div>
        <RewardList v-if="code == 'MEMBER'" :benefits="data.benefit" :card_name="data.card_name"></RewardList>
      </div>
    </template>
    <BottomNavbar></BottomNavbar>
  </div>
</template>
<script>
  import BottomNavbar from '@/components/hotel/BottomNavbar';
  import MemberCard from '@/components/hotel/concierge/member/MemberCard'
  import RewardList from '@/components/hotel/concierge/member/RewardList'
  import {mapGetters} from "vuex";

  export default{
    props:{
      all_data:{
        type: Object,
        default: () => {}
      }
    },
    components: {
      BottomNavbar,
      MemberCard,
      RewardList
    },
    data() {
      return {
        scrollPosition: null,
        data:{},
        code: '',
        guest_name: ''

      }
    },
    created(){
      this.data = this.all_data.data
      this.code = this.all_data.code
      this.guest_name = this.getCurrentUser().first_name+' '+(this.getCurrentUser().last_name != null ? this.getCurrentUser().last_name : '')
    },
    mounted() {
      if(this.$route.query.scrollTo != undefined){
        document.getElementById('reward_list').scrollIntoView({
          behavior: 'smooth'
        });
      }else{
        document.getElementById('Reward').scrollIntoView({
          behavior: 'smooth'
        });
      }
    },
    methods: {
      ...mapGetters(['getMerchant','getCurrentUser']),
      parsingDataCard(data){
        if(this.code == 'MEMBER'){
          let copied = JSON.parse(JSON.stringify(data))
          delete copied.benefit
          delete copied.return_product
          delete copied.promotion_list
          return copied
        }else{
          return data.membership
        }
      },
      goToCardList(){
        this.$emit('card_list')
      },
      cardClicked(){
        if(this.data.status == 'PENDING'){
          this.$emit('reload')
        }
      }
    }
  }
</script>
<style scoped>
.search-custom {
  background-image: url('../../../../assets/img/hotel/search.png');
  height: 44px;
  background-color: #f4f4f4b8  !important;
  background-position: 16px 14px;
  background-size: 15px 15px;
  -o-object-fit: cover;
  object-fit: cover;
  background-repeat: no-repeat;
  padding: 5px 30px 7px 44px;
}

.left-0-d{
  left: 0!important
}

.tutor_reward{
  width: 200px;
  float: right;
  right: 20px;
  position: relative;
}

.tutor_reward:before{
  content: "";
  top: -7px;
  right: 12px;
  position: absolute;
  border-right: 7px solid transparent;
  border-left: 7px solid transparent;
  border-bottom: 7px solid #fff;
}

@media screen and (max-width: 655px) {
  .mobile-none{
    display: none !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/member/UserMember.vue